import React, { useEffect, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import UserContext from '../../../config/UserContext'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner
} from '../../../config/react'
import DataTable from 'react-data-table-component'

const Banner = () => {
  const [BannerList, setBannerList] = useState([])
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [IsAuth, setIsAuth] = useState(true)
  const [loading, setLoading] = useState(false)

  const columns = [
    {
      name: 'Name',
      sortable: true,
      sortField: 'name',
      selector: (row) => row.name
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) => (row.status ? 'Active' : 'Inactive')
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/widgets/banner/edit/' + row.id}
            className="text-dark"
            title="Edit"
          >
            <i
              className="fa fa-pencil-square-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
          <Link
            onClick={(e) => DeleteBanner(e, row.id)}
            to=""
            className="text-dark"
            title="Delete"
          >
            <i
              className="fa fa-trash-o"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  const GetBannerList = () => {
    setLoading(true)
    const param = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    // console.log('LN 63 page '+CustomFilters.page+' &page_size '+CustomFilters.page_size);
    HttpService.postApi(API.GetBannerList, param).then((response) => {
      setLoading(false)
      // console.log(response.data.result);
      setBannerList(response.data.result[1])
      settotalRows(response.data.result[0][0].total)
      setForceUpdate(!isForceUpdate)
    })
  }
  const DeleteBanner = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id,
          IsDeleted: true,
          deleted_by: user.id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteBanner, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetBannerList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  useEffect(() => {
    setIsAuth(true)
    document.title = Title.Banner

    GetBannerList()
  }, [CustomFilters])

  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
    // console.log('LN 105 Page 1' + ' &page_size ' + e)
  }
  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Name."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
      />
    )
  })
  const handleSort = (e, direction) => {
    // console.log('LN 112 Sort FIeld ' + e.sortField)
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.Banner} </h3>
        <div className="btn-group">
          <Link
            to="/widgets/banner/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Banner{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  // title="Coupons"
                  columns={columns}
                  data={BannerList}
                  // progressPending={loading}
                  progressPending={loading}
                  persistTableHead={true}
                  progressComponent={<Spinner />}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Banner
